import {TSyncfield_Group} from "../../constants/Syncfields";

export namespace nsWizard {

    export const Syncfield_mandatory: ReadonlyArray<TSyncfield_Group> = [
        'Name',
        'SourceId',
        'Description',
        'MemberRuleSetId',
        'Parent',
    ] as const

    export const Syncfield_optional: ReadonlyArray<TSyncfield_Group> = [
        'ExpiryDate',
        'ExtensionAttribute1',
        'ExtensionAttribute2',
        'ExtensionAttribute3',
        'ExtensionAttribute4',
        'ExtensionAttribute5',
        'GroupType',
        'Level',
        'Mail',
        'Manager',
        'OrgUnitnr',
        'ParentDepartmentNumber',
        // 'SystemRoleFilterId', // a surprise from Manuel
        // 'SystemRoles', // a surprise from Manuel
    ]
}